/**
 * @file Constant.js
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2020/06/17
 */
import {getParamsFromUrl, getPlatInfo} from '@baidu/map-fe-utils';

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    // // Const.server = 'http://yangshujia.bcc-szwg.baidu.com:8085/';
    // Const.server = 'http://yangxuya.bcc-gzbh.baidu.com:8082/';
    // Const.server = 'http://yq02-ps-beehive-agent293422.yq02.baidu.com:8010/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8052/';
    Const.server = 'https://yongche.baidu.com/';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    // // Const.server = 'http://yangshujia.bcc-szwg.baidu.com:8085/';
    // Const.server = 'http://yangxuya.bcc-gzbh.baidu.com:8082/';
    // Const.server = 'http://yq02-ps-beehive-agent293422.yq02.baidu.com:8010/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8052/';
    Const.server = 'https://yongche.baidu.com/';
}
// 线上环境
else {
    // // Const.server = 'http://yangshujia.bcc-szwg.baidu.com:8085/';
    // Const.server = 'http://yangxuya.bcc-gzbh.baidu.com:8082/';
    // Const.server = 'http://yq02-ps-beehive-agent293422.yq02.baidu.com:8010/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8052/';
    // Const.server = 'http://yq01-ps-201706-m12-9-www096.yq01.baidu.com:8023/';
    Const.server = 'https://yongche.baidu.com/';
}
Const.dataUrl = {
    MainData: {
        isMock: 0,
        url: Const.server + 'marketing/yongcheactivity/commonactivity'
    },
    GetCardDetail: {
        isMock: 0,
        url: Const.server + 'marketing/yongcheactivity/commonactivityrefresh'
    },
    GetCard: {
        isMock: 0,
        url: Const.server + 'marketing/yongcheactivity/commonactivityoperate'
    },
    GetTask: {
        isMock: 0,
        url: Const.server + 'gomarketing/api/activity/drawtask'
    },
    GetCou: {
        isMock: 0,
        url: Const.server + 'marketing/yongcheactivity/commonactivityoperate'
    }
    // http://yangshujia.bcc-szwg.baidu.com:8085/gomarketing/api/activity/drawtask
    // http://yangshujia.bcc-szwg.baidu.com:8085/marketing/yongcheactivity/commonactivityoperate
};

// 活动列表
Const.activityType = {
    default: 'jiuyudacu'
};
const {activity = Const.activityType.default} = getParamsFromUrl();

// 开发测试配置
if (process.env.NODE_ENV === 'development') {
    /** ****** offline ***** */
    Const.devTap = {
        needBackToNative: false,
        isNative: true,
        backUrl: location.origin + location.pathname + '?activity=' + activity
    };
}
else {
    /** ****** online ****** */
    Const.devTap = {
        // JumpFunc中通用调端方法中，是否需要调起端的参数
        needBackToNative: true,
        // 基础store中，判断页面当前是否在端内
        isNative: getPlatInfo().isNative,
        // JumpFunc中通用调端方法中，返回端内时的默认地址
        backUrl: location.origin + location.pathname + '?activity=' + activity
    };
}

// 样式标签
Const.styleLabel = {
    image: ['backgroundImage'],
    number: [
        'width', 'height', 'left', 'right', 'top', 'bottom',
        'margin', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom',
        'padding', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom',
        'borderRadius'
    ]
};

// 活动eventKey
Const.eventKeys = {
    default: 'shop_cooperation'
};

// 活动列表数据反转 {commuting_activities: 'commuting'}
Const.activityTypeRef = {};
Object.keys(Const.activityType).forEach(key => {
    Const.activityTypeRef[Const.activityType[key]] = key;
});
// 获取活动列表key的数组 ['default', 'commuting_activities']
Const.activityTypeKeys = Object.keys(Const.activityTypeRef);
Const.loginType = {
    notNeed: 0,
    entry: 1,
    click: 2
};

// 模块按钮点击类型
Const.buttonType = {
    // 请求
    request: 'request',
    // 显示toast
    toast: 'toast',
    // 页面事件
    method: 'method',
    // 直接跳转
    direct: 'direct'
};
// 模块背景点击类型
Const.cardClickType = {
    // modal弹窗
    modal: 'modal'
};

// 请求响应类型
Const.responseType = {
    // toast
    toast: 'toast',
    // 弹窗
    dialog: 'dialog'
};

// 活动状态
Const.activityStatus = {
    // 活动未开始
    notStarted: 0,
    // 正常
    hasStarted: 1,
    // 紧急下线
    endNow: 2,
    // 已结束
    hasEnded: 9
};

// 优惠券状态
Const.cardStatus = {
    // 未到秒杀开始时间
    notStarted: 0,
    // 正常
    doing: 1,
    // 无库存
    noMore: 2,
    // 已领取
    received: 4
};

// 首页弹窗
Const.mainDialogNum = {
    // 规则
    rules: 1,
    // 挽留弹框
    askToStay: 2,
    // 活动状态
    imageBox: 3,
    // modal底部弹窗
    modal: 4
};

// 客户端信息
Const.nativeInfo = {};
export default Const;
